import {Request} from './Request';

export class GetDiagnosticsRequest implements Request {
    chargePointSelectList: string[];

    private location: string;
    private retries: number;
    private retryInterval: number;
    private start: Date;
    private stop: Date;

    constructor(chargePointSelectList: string[], location?: string, retries?: number,
                retryInterval?: number, start?: Date, stop?: Date) {
        this.chargePointSelectList = chargePointSelectList;
        this.location = location;
        this.retries = retries;
        this.retryInterval = retryInterval;
        this.start = start;
        this.stop = stop;
    }

    public toString = (): string => {
        return `GetDiagnosticsRequest (location: ${this.location},
        retries: ${this.retries}, retryInterval: ${this.retryInterval},
        start: ${this.start},
        stop: ${this.stop})`;
    }


    get _location(): string {
        return this.location;
    }

    set _location(value: string) {
        this.location = value;
    }

    get _retries(): number {
        return this.retries;
    }

    set _retries(value: number) {
        this.retries = value;
    }

    get retry_interval(): number {
        return this.retryInterval;
    }

    set retry_interval(value: number) {
        this.retryInterval = value;
    }

    get _start(): Date {
        return this.start;
    }

    set _start(value: Date) {
        this.start = value;
    }

    get _stop(): Date {
        return this.stop;
    }

    set _stop(value: Date) {
        this.stop = value;
    }
}


/*

chargePointSelectList: JSON;EVB-P20261797;-
chargePointSelectList: 1
location: https://www.google.com
retries: 10
retryInterval: 2
start: 2022-09-12 04:23
stop: 2022-09-19 00:00
csrf: 3e268a18-2879-4b62-b529-62c9177695d8


 */
